export const defaultCategories = [
  "Food",
  "Rent",
  "Entertainment",
  "Clothing",
  "Travel&Transport",
  "Medical",
];
